/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { Block } from './Block';

export default Block;

/**
 * @deprecated Use `import { Block } from '@atlaskit/smart-card/block'` instead.
 */
export { Block } from './Block';
